export default function ChartDataController() {
}

ChartDataController.prototype.init = function(chartPoints, stackColumns)
{
    this.chartPoints = chartPoints
    this.stackColumns = stackColumns
    this.calculateTotalMaxMin()
    return this
}

ChartDataController.prototype.updateData = function( chartPoints, stackColumns )
{
    this.chartPoints = chartPoints
    this.stackColumns = stackColumns
    this.calculateTotalMaxMin()
}

ChartDataController.prototype.getCountPoints = function () {
    return this.chartPoints.length;
};

ChartDataController.prototype.getTotal = function (){
    return this.total ? this.total : 0;
};
ChartDataController.prototype.getMaxValue = function (){
    return this.maxValue;
};
ChartDataController.prototype.getMinValue = function (){
    return this.minValue;
};

ChartDataController.prototype.calculateTotalMaxMin = function ()
{
    if (!this.chartPoints || !this.chartPoints.length) {
        return
    }

    let min = this.chartPoints[0].value.total
    let max = this.chartPoints[0].value.total
    let total = 0

    this.chartPoints.forEach((point) => {
        let value = point.value.total

        if (value > max) max = value
        if (value < min) min = value

        total += value
    })

    this.total = total
    this.minValue = min
    this.maxValue = max
};


// WEBPACK FOOTER //
// ./web/js/reports/charts/ChartDataController.js